import { create } from "zustand";
import api from "../../../../../../api";

export let usePreviewEmailModal = create((set, get) => ({
  display: false,
  vendorIndex: undefined,
  vendorName: "Vendor",
  vendorId: undefined,
  email: "",
  cc_email_1: "",
  cc_email_2: "",
  subject: "",
  emailBody: undefined,
  purchaseOrderId: undefined,

  showPreviewEmailModal: async (
    vendorIndex,
    vendorName,
    vendorId,
    purchaseOrderId,
  ) => {
    const { email, cc_email_1, cc_email_2, subject, text } =
      await api.vendor.getInquirePreviewEmail(vendorId, purchaseOrderId);

    set({
      vendorIndex,
      vendorName,
      vendorId,
      email,
      cc_email_1,
      cc_email_2,
      subject,
      emailBody: text,
      purchaseOrderId,
      display: true,
    });
  },

  handleEmailBody: (emailBody) => {
    set({ emailBody });
  },
  handleEmail: (email) => {
    set({ email });
  },
  handleCcEmail1: (cc_email_1) => {
    set({ cc_email_1 });
  },
  handleCcEmail2: (cc_email_2) => {
    set({ cc_email_2 });
  },
  handleSubject: (subject) => {
    set({ subject });
  },
  closeModal: () => {
    set({ display: false });
  },
}));
